import styled from 'styled-components';
import device from '../../../mediaQueries';

const LinkGroupHeading = styled.div`
  white-space: nowrap;
  color: #fff;
  text-transform: uppercase;
  user-select: none;
  display: flex;
  font-family: 'Avenir Black', 'Arial Black', sans-serif;
  font-size: 13px;
  letter-spacing: 1px;

  ${device.desktop`
    letter-spacing: 1px;
    text-transform: uppercase;
    clear: both;
    margin: 9px 0;
    height: 20px;
  `}

  ${device.mobile`
    outline: none;
    padding: 0 5%;
    border-bottom: 1px solid #999999;
    align-items: center;
  `}
`;

export default LinkGroupHeading;
